import fetch from 'isomorphic-fetch'

import Config from '../config'

import SecureStorage from './encrypt'

const handleHTTPErrors = (res) => {
  if (res.ok) return res
  return res.json().then((err) => { throw err })
}

export default (url, options) => {
  // Get encrypted authorization token from the local storage
  const jwtToken = localStorage.getItem(Config.LocalStorageKeys.Authorization)
  if (jwtToken) {
    let authAddedOptions = options
    if (typeof options !== 'object') {
      authAddedOptions = {}
    }
    if (typeof authAddedOptions.headers !== 'object') {
      authAddedOptions.headers = {}
    }
    // Token is encrpted so need to decrypt before calling API
    const token = jwtToken ? SecureStorage.decrypt(jwtToken) : ''
    authAddedOptions.headers = {
      ...authAddedOptions.headers,
      Authorization: 'Bearer ' + token
    }
    return fetch(url, authAddedOptions).then(handleHTTPErrors)
  } else {
    return fetch(url, options).then(handleHTTPErrors)
  }
}



// WEBPACK FOOTER //
// ./src/utils/fetch.js